export const isTouchpointFunnelVisible = (data = []) => {
    const daysFromFirstTouchpoint = data.find((item) => item.id === 'days-from-first-touchpoint');
    const daysFromLastTouchpoint = data.find((item) => item.id === 'days-from-last-touchpoint');

    const daysFromFirstTouchpointCondition = Number(daysFromFirstTouchpoint?.value) >= 4;
    const daysFromLastTouchpointCondition = Number(daysFromLastTouchpoint?.value) <= 1;

    return daysFromFirstTouchpointCondition && daysFromLastTouchpointCondition;
};
